/**
 * iurop-cart-page.js — Página /cart (sections/iurop-cart-page.liquid)
 * ---------------------------------------------------------------------------
 * Cantidades y eliminar sin recargar: POST /cart/change.js pidiendo de vuelta
 * la sección `iurop-cart-page` (Section Rendering API) y se re-pinta el bloque
 * [data-cart-page]. Después dispara `cart:updated` con `noOpen: true` para que
 * iurop-cart-drawer.js refresque el sidecart y el contador del header SIN
 * abrir el drawer encima de la página.
 *
 * Selectores PROPIOS ([data-cp-*]) a propósito: iurop-cart-drawer.js escucha
 * [data-qty-up]/[data-cart-remove] delegado en `document`, así que reutilizar
 * esos nombres haría que el drawer se llevara el clic y solo se refrescara él.
 *
 * Sin JS la página sigue funcionando: el "eliminar" es un <a> a
 * /cart/change?id=…&quantity=0 y el checkout es el submit del form nativo.
 */
(function () {
  var SECTION = 'iurop-cart-page';

  function root() {
    return document.querySelector('[data-cart-page]');
  }

  var busy = false;
  var pending = {}; // key -> cantidad deseada (coalescing de clics rápidos)

  function notifyCart(count) {
    // Contador del header al día ANTES de avisar al drawer (su refresh lee el
    // contador que ya hay pintado).
    if (typeof count === 'number') {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = count;
      });
    }
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { noOpen: true } }));
  }

  function swap(html) {
    var live = root();
    if (!live || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var next = doc.querySelector('[data-cart-page]');
    if (!next) return;
    // La nota del pedido se conserva: el re-pintado traería el valor guardado
    // en el carrito, no lo que el usuario acaba de escribir.
    var oldNote = live.querySelector('[data-cp-note]');
    var newNote = next.querySelector('[data-cp-note]');
    if (oldNote && newNote) newNote.value = oldNote.value;
    live.replaceWith(next);
  }

  function reloadIfEmptyFail() {
    window.location.reload();
  }

  function send(key, quantity) {
    if (busy) return;
    busy = true;
    var live = root();
    if (live) live.setAttribute('data-busy', 'true');

    var changeUrl = (window.routes && window.routes.cart_change_url) || '/cart/change';
    fetch(changeUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: key,
        quantity: quantity,
        sections: SECTION,
        sections_url: window.location.pathname
      })
    })
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (cart) {
        if (cart && cart.sections && cart.sections[SECTION]) {
          swap(cart.sections[SECTION]);
        } else {
          reloadIfEmptyFail();
          return;
        }
        notifyCart(typeof cart.item_count === 'number' ? cart.item_count : undefined);
      })
      .catch(function () {})
      .then(function () {
        busy = false;
        var el = root();
        if (el) el.removeAttribute('data-busy');
        flush();
      });
  }

  function flush() {
    if (busy) return;
    var keys = Object.keys(pending);
    if (!keys.length) return;
    var key = keys[0];
    var q = pending[key];
    delete pending[key];
    send(key, q);
  }

  function queue(key, q) {
    pending[key] = q;
    flush();
  }

  function currentQty(li, key) {
    if (pending[key] != null) return pending[key];
    var v = li && li.querySelector('.gudslip-cartpage__qty-value');
    return (v && parseInt(v.textContent, 10)) || 0;
  }

  function bump(btn, delta) {
    var key = btn.getAttribute('data-key');
    var li = btn.closest('.gudslip-cartpage__item');
    var q = currentQty(li, key) + delta;
    if (q <= 0) {
      if (li) li.classList.add('is-removing');
      queue(key, 0);
      return;
    }
    // Actualización optimista: el número cambia ya; el servidor confirma luego.
    var v = li && li.querySelector('.gudslip-cartpage__qty-value');
    if (v) v.textContent = q;
    if (li) {
      var u = li.querySelector('[data-cp-qty-up]');
      var d = li.querySelector('[data-cp-qty-down]');
      if (u) u.setAttribute('data-qty', q);
      if (d) d.setAttribute('data-qty', q);
    }
    queue(key, q);
  }

  document.addEventListener('click', function (e) {
    var up = e.target.closest && e.target.closest('[data-cp-qty-up]');
    if (up) {
      e.preventDefault();
      bump(up, 1);
      return;
    }
    var down = e.target.closest && e.target.closest('[data-cp-qty-down]');
    if (down) {
      e.preventDefault();
      bump(down, -1);
      return;
    }
    var rm = e.target.closest && e.target.closest('[data-cp-remove]');
    if (rm) {
      e.preventDefault();
      var li = rm.closest('.gudslip-cartpage__item');
      if (li) li.classList.add('is-removing');
      queue(rm.getAttribute('data-key'), 0);
    }
  });
})();
